import React from 'react'
import type { Person } from '@fs/zion-tree-types'
import { Row, Button, IconButton } from '@fs/zion-ui'
import { TreePedigree } from '@fs/zion-icon'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import RelationshipViewerButton from '@fs/zion-relationship-viewer'
import Follow from '@fs/zion-follow'

const marginOverrideCss = css`
  & button,
  a {
    margin: 0;
  }
`

type Props = {
  focusPerson: Person
  hideText?: boolean
}

export default function BannerActions({ focusPerson, hideText }: Props): JSX.Element {
  const [t] = useTranslation()
  const disabledButtons = focusPerson?.deleted
  const externalPropObj = disabledButtons ? {} : { external: true }
  const viewTreeTo = disabledButtons ? undefined : `/tree/pedigree/${focusPerson.id}`
  // disabled doesn't work with a to — even though we get console errors the button only gets the correct url when using external
  const viewTreeProps = {
    Icon: TreePedigree,
    linkName: 'Person Header View Tree',
    to: viewTreeTo,
    ...externalPropObj,
    disabled: disabledButtons,
    title: hideText ? t('tree-person.view-tree.action') : '',
  }

  return (
    <div css={marginOverrideCss}>
      <Row wrap alignY="middle" guttersY="nano" guttersX="xxs">
        {hideText ? (
          <IconButton data-testid="view-tree-button" {...viewTreeProps}>
            {t('tree-person.view-tree.action')}
          </IconButton>
        ) : (
          <Button data-testid="view-tree-button" {...viewTreeProps}>
            {t('tree-person.view-tree.action')}
          </Button>
        )}

        {!focusPerson.researcherTree && (
          <RelationshipViewerButton
            data-testid="relationship-viewer-button"
            toId={focusPerson.id}
            hideText={hideText}
            disabled={disabledButtons}
          />
        )}
        <Follow personObj={focusPerson} showText={!hideText} buttonProps={{ emphasis: hideText ? 'medium' : 'low' }} />
      </Row>
    </div>
  )
}
